import React from 'react';
import { Route, Routes } from "react-router-dom";
import SendOutCollectionCreateScreen from "screens/App/CRM/SendOutCollection/SendOutCollectionCreateScreen";
import SendOutCollectionDetailScreen from "screens/App/CRM/SendOutCollection/SendOutCollectionDetailScreen";
import SendOutCollectionEditScreen from "screens/App/CRM/SendOutCollection/SendOutCollectionEditScreen";
import SendOutCollectionListScreen from "screens/App/CRM/SendOutCollection/SendOutCollectionListScreen";

import NotFoundScreen from "screens/NotFoundScreen";

const SendOutCollectionRouter = () => {
    return (
        <Routes>
            <Route path="create" element={<SendOutCollectionCreateScreen />} />
            <Route path="list" element={<SendOutCollectionListScreen />} />
            <Route path=":id/detail" element={<SendOutCollectionDetailScreen />} />
            <Route path=":id/edit" element={<SendOutCollectionEditScreen />} />
            <Route path="*" element={<NotFoundScreen />} />
        </Routes>
    );
};

export default  SendOutCollectionRouter;
    
